import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgCheckLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1 12.11L8.25999 19.25L23 4.75"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgCheckLarge.displayName = 'SvgCheckLarge';
const CheckLarge = withForgeIconProps(SvgCheckLarge, {
  name: 'Check',
  usage: 'Use to indicate or mark an item as completed or selected.',
  related: 'yes, done, okay, select, complete, checked',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default CheckLarge;
